var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-reset"},_vm._l((_vm.tree.root),function(item){return _c('database-filter-item',{key:item.id,attrs:{"model":item,"codes":_vm.codes,"folder-select":_vm.folderSelect}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }